import { BLINK_FLAGS, envFlags } from '@thoughtspot/env-flags';
import { getValue } from '@thoughtspot/session-service';
import DOMPurify from 'dompurify';
import _ from 'lodash';
export const getFlagsFromEventData = (flags) => {
    const result = {};
    flags.forEach((flag) => {
        const sanitizedFlag = DOMPurify.sanitize(flag);
        if (Object.hasOwn(BLINK_FLAGS, sanitizedFlag)) {
            const urlFlag = envFlags.getValue(BLINK_FLAGS[sanitizedFlag].name);
            result[sanitizedFlag] = {
                flagId: sanitizedFlag,
                flagValue: !_.isUndefined(urlFlag)
                    ? urlFlag
                    : getValue(BLINK_FLAGS[sanitizedFlag]),
            };
        }
    });
    return result;
};
//# sourceMappingURL=utils.js.map